import axios from "axios";

const http = axios.create({
	baseURL: process.env.REACT_APP_SERVER_API_URL,
	// baseURL: "http://localhost:8080"
});

http.interceptors.response.use(
	(response) => response,
	(error) => {
		if (error.response?.status === 403 && error.response?.data?.message?.includes("suspended")) {
			localStorage.removeItem("token");
			window.location.href = "/login";
		}
		return Promise.reject(error);
	}
);

export default http;
